import { BsThreeDotsVertical } from "react-icons/bs";
import { DropDownComp } from "../../components";

export const SettingBranchHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => <span className="text-muted">{row.serialNumber}</span>,
      width: "70px",
    },
    {
      name: "Branch name",
      selector: (row) => <span style={{ width: "50px" }}>{row?.name}</span>,
      width: "300px",
    },
    {
      name: "Address",
      selector: (row) => (
        <div className="px-3 d-flex align-items-center">
          {row?.address?.replace(/ 0$/, "") || row?.address}
        </div>
      ),
    },
    {
      name: "Contact",
      selector: (row) => (
        <div>
          <div
            style={{ fontWeight: "600", color: "var(--color-link)", marginBottom: "2px" }}
          >
            {row?.phone}
          </div>
          <div style={{ color: "#6c757d", fontSize: "12px" }}>{row?.email}</div>
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={
              typeof TableDropDown === "function"
                ? TableDropDown(row)
                : TableDropDown
            }
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span className="table-action-icon">
                <BsThreeDotsVertical size={20} />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },
  ];
};
